<template>
  <v-card class="border physical-activity-goal-setting">
    <p-a-goal-setting-tabs />
    <router-view></router-view>
  </v-card>
</template>

<script>
import PAGoalSettingTabs from "../../../components/Parts/PAGoalSettingTabs.vue";

/**
 * Component PatientOverviewPAGoalSetting.vue
 *
 * @module PatientOverviewPAGoalSetting
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.7] app/src/APP_DASHBOARD/templates/views/Patient/PA/PatientOverviewPAGoalSetting.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PatientOverviewPAGoalSetting',
  components: {
    PAGoalSettingTabs,
  },
};
</script>

<style lang="scss">

</style>
